let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l9k0q")).then(() => parcelRequire('3H9aq'));